import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  Stop,
} from 'react-native-svg'

const ErrorFilled = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="url(#b)"
        d="M10 2c-4.417 0-8 3.583-8 8s3.583 8 8 8 8-3.583 8-8-3.583-8-8-8Zm.775 11.083a.917.917 0 0 1-.675.275.923.923 0 0 1-.683-.275.923.923 0 0 1-.275-.683c0-.275.091-.5.275-.683a.923.923 0 0 1 .683-.275c.275 0 .5.091.675.275a.923.923 0 0 1 .275.683c0 .275-.092.5-.275.683Zm.367-5.683-.525 3.067a.575.575 0 0 1-.175.391.491.491 0 0 1-.35.142.491.491 0 0 1-.35-.142.69.69 0 0 1-.184-.391l-.516-3.075s-.009-.092-.009-.159c0-.3.1-.525.3-.7.2-.166.45-.25.759-.25.308 0 .566.084.758.259.2.175.3.408.3.7 0 .066 0 .116-.008.158Z"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={10}
        x2={10}
        y1={2}
        y2={18}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFC793" />
        <Stop offset={1} stopColor="#D89659" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default ErrorFilled
